import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  getContainingRealStationSegmentInsertAfterIndex,
  getStationRouteWaypointSegmentOptions,
  IStationRouteStationInfo,
} from "@ryde/shared";

import { StationRouteWaypointSegmentPickerStyled } from "./station-route-waypoint.styled";

interface IStationRouteWaypointSegmentPickerProps {
  stations: IStationRouteStationInfo[];
  selectedInsertAfterIndex: number | undefined;
  onSelectInsertAfterIndex: (insertAfterIndex: number) => void;
}

export const StationRouteWaypointSegmentPicker: FC<
  IStationRouteWaypointSegmentPickerProps
> = ({ stations, selectedInsertAfterIndex, onSelectInsertAfterIndex }) => {
  const { t } = useTranslation();

  const segmentOptions = useMemo(
    () => getStationRouteWaypointSegmentOptions(stations),
    [stations],
  );

  const selectedSegmentInsertAfterIndex = useMemo(
    () =>
      selectedInsertAfterIndex === undefined
        ? segmentOptions[0]?.insertAfterIndex
        : getContainingRealStationSegmentInsertAfterIndex({
            stations,
            insertAfterIndex: selectedInsertAfterIndex,
          }),
    [segmentOptions, selectedInsertAfterIndex, stations],
  );

  if (!segmentOptions.length) {
    return null;
  }

  return (
    <StationRouteWaypointSegmentPickerStyled>
      <div className="segment-title">
        {t("stationRoute.waypoint.SEGMENT_TITLE")}
      </div>
      <RadioGroup
        className="segment-options"
        value={selectedSegmentInsertAfterIndex ?? ""}
        onChange={(_, value) => onSelectInsertAfterIndex(Number(value))}
      >
        {segmentOptions.map(option => (
          <FormControlLabel
            key={option.insertAfterIndex}
            value={option.insertAfterIndex}
            control={<Radio size="small" />}
            className="segment-option"
            label={t("stationRoute.waypoint.SEGMENT_BETWEEN", {
              from: option.fromName,
              to: option.toName,
            })}
          />
        ))}
      </RadioGroup>
    </StationRouteWaypointSegmentPickerStyled>
  );
};
